module.exports = __webpack_public_path__ + "media/img/android-icon-192x192-186155cb5c9e9dec49e0c2c594089b95.png";